import type { SubmissionStatus } from "@/lib/submissions/brokerSubmissions";
import { statusBadgeClass, statusLabel } from "@/lib/listFormat";

/** A submission's own status as a chip (BRK-S254), in the words the detail
 *  page uses. `outlined` rings it, for a chip on the grey page rather than in
 *  a white row, where a neutral one would otherwise blend in (BRK-S358). */
export function SubmissionStatusChip({
  status,
  outlined = false,
}: {
  status: SubmissionStatus;
  outlined?: boolean;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${statusBadgeClass(status)} ${
        outlined ? "ring-1 ring-inset ring-brk-border" : ""
      }`}
    >
      {statusLabel(status)}
    </span>
  );
}
